import {observer} from "mobx-react";
import ButtonNew from "@dropDesk/presentation/components/buttons/button_new";
import {ICONS_DROPDESK} from "@dropDesk/storage/icons/icons.d";
import PopOver from "@dropDesk/presentation/components/popup/pop_confirm";
import React from "react";
import {useInjection} from "inversify-react";
import {AppController} from "@dropDesk/presentation/app/app.controller";
import {SharedColors} from "@dropDesk/domain/entities/theme/app_colors";
import {ButtonWrapper, FilterCountBadge} from "./styled";
import {Tooltip} from "antd";

const FilterButton = observer(
    ({
         loading,
         content,
         hasFilter,
         open,
         onOpenChange,
         zIndex,
         filterCount = 0,
         radius = 25,
         marginLeft = 10,
         iconOnly = false,
     }: {
        loading: boolean
        content: React.ReactNode;
        hasFilter: boolean
        setVisiblePopoverExternal?: () => {}
        open?: boolean;
        onOpenChange?: ((value: boolean) => void) | undefined
        zIndex?: number
        filterCount?: number
        radius?: number
        marginLeft?: number
        iconOnly?: boolean
    }) => {
        const appController = useInjection(AppController);
        const colors = appController.theme.colorScheme;
        const label = iconOnly ? '' : (filterCount > 0 ? `Filtros (${filterCount})` : 'Filtros');

        const button = (
            <ButtonWrapper style={{marginLeft}}>
                <ButtonNew
                    className="button-filter-journey"
                    marginLeft={0}
                    label={label}
                    onClick={() => {
                    }}
                    nameLeftIcon={ICONS_DROPDESK.filter}
                    sizeLeftIcon={14}
                    disabled={loading}
                    radius={radius}
                    zIndex={zIndex}
                    color={hasFilter ? colors.accent : undefined}
                    focusBorder={open}
                    size={iconOnly ? 40 : undefined}
                    widthButton={iconOnly ? 40 : undefined}
                />
                {filterCount > 0 && (
                    <FilterCountBadge
                        background={colors.accent}
                        color={SharedColors.white}
                    >
                        {filterCount}
                    </FilterCountBadge>
                )}
            </ButtonWrapper>
        );

        return (
            <PopOver
                open={open}
                onOpenChange={onOpenChange}
                placement={iconOnly ? "bottomRight" : "bottomLeft"}
                trigger="click"
                showArrow={false}
                overlayInnerStyle={iconOnly ? undefined : {marginTop: -52, marginLeft: -10}}
                content={content}
            >
                {iconOnly ? (
                    <Tooltip title={'Filtros'}>
                        {button}
                    </Tooltip>
                ) : button}
            </PopOver>
        )
    })
export default FilterButton;
